import "./user-list.scss";
import { useContext, useEffect, useState, } from "react";

import ListPage from "../../../shared/components/list-page/list-page";
import { IColumn } from "../../../shared/components/normal-table/normal-table";
import Spinner from "../../../shared/components/spinner/spinner";
import { roleWrite } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData, deleteMultiple, IListPageData } from "../../../shared/utils/api";
import { validateLoadingStatusNew } from "../../../shared/utils/utils";
import { userListUrl } from "../../constants/backend-constants";

const columns: IColumn[] = [
  {
    key: "email",
    displayName: "Email Address",
    dataType: {
      type: "text",
    }
  },
  {
    key: "name",
    displayName: "First Name",
    dataType: {
      type: "text",
    }
  },
  {
    key: "last_name",
    displayName: "Last Name",
    dataType: {
      type: "text",
    }
  },
  {
    key: "active_status",
    displayName: "Active",
    dataType: {
      type: "text",
    }
  },
];

const UserList = () => {
  const [data, setData] = useState<IListPageData | undefined>(undefined);
  const [unblockInput, setUnblockInput] = useState(false);
  const [sortedBy, setSortedBy] = useState("?order_by=email asc");
  const [currentOffset, setCurrentOffset] = useState(1);
  const authCtx = useContext(AuthContext);
  const { sendRequest: getSortBy, status: getSortByStatus, data: getSortByData, error: errorGetSortByData } = useHttp(getAllData, true, authCtx.token);
  const { sendRequest: deleteMultipleRequest, status: allStatusDelete, data: loadedDataDelete, error: errorDelete } = useHttp(deleteMultiple, false, authCtx.token);
  const { sendRequest: getSortByPagination, status: getSortByPaginationStatus, data: getSortByPaginationData, error: getSortByPaginationError } = useHttp(getAllData, false, authCtx.token);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.indexOf(roleWrite) === -1 || authCtx.systemAdmin) {
      setUnblockInput(true);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  useEffect(() => {
    getSortBy("users", "?order_by=email asc&limit=50&offset=0");
  }, [getSortBy]);

  const onTableScrollAction = (offset: number) => {
    if (data && data.rows.length >= 50) {
      setCurrentOffset(offset);
      if (!getSortByPaginationData) {
        getSortByPagination("users", `${sortedBy}&limit=50&offset=${offset * 50}`);
      } else if (getSortByPaginationData.rows.length !== 0) {
        getSortByPagination("users", `${sortedBy}&limit=50&offset=${offset * 50}`);
      }
    }
  };

  useEffect(() => {
    if (getSortByPaginationStatus === "completed" && !getSortByPaginationError) {
      data && setData({rows: [...data.rows, ...getSortByPaginationData.rows]});
    }
  }, [getSortByPaginationStatus]);

  useEffect(() => {
    if (getSortByStatus === "completed" && !errorGetSortByData) {
      setData(getSortByData);
    }
  }, [getSortByStatus]);

  useEffect(() => {
    if (allStatusDelete === "completed" && !errorDelete) {
      setData(loadedDataDelete);
    }
  }, [allStatusDelete]);

  const handleOnDelete = (ids: string[]) => {
    deleteMultipleRequest(`users${sortedBy}&limit=${currentOffset * 50}&offset=0`, { ids });
  };

  const sortBy = (sortingQuery: string) => {
    getSortBy("users", `${sortingQuery}&limit=${currentOffset * 50}&offset=0`);
    setSortedBy(sortingQuery);
  };

  return (
    <div className="userList">
      {validateLoadingStatusNew([getSortByStatus, allStatusDelete, getSortByPaginationStatus]) && <Spinner />}
      <ListPage
        title={"Users"}
        sortBy={sortBy}
        defaultSortCol={"email"}
        unblockInput={unblockInput}
        columns={columns}
        dataUrl={userListUrl}
        onTableScrollAction={onTableScrollAction}
        pageMode={"nonEditable"}
        handleOnDelete={handleOnDelete}
        fetchedData={data}
        allStatus={getSortByStatus}
        allStatusDelete={allStatusDelete}
      />
    </div>
  );
};

export default UserList;
